module.exports = __webpack_public_path__ + "img/logo.30a4e0c0.png";